// src/hooks/useProjects.js
import { useQuery, useMutation } from "@apollo/client";
import {
  GET_DISPLAY_PROJECTS,
  INSERT_PROJECT,
  UPDATE_PROJECT,
  DELETE_PROJECT,
} from "../../graphql/homepage/project";

export const useDisplayProjects = () => {
  return useQuery(GET_DISPLAY_PROJECTS);
};

export const useInsertProject = () => {
  return useMutation(INSERT_PROJECT, {
    update(cache, { data: { insert_home_page_project_one: newProject } }) {
      const existingProjects = cache.readQuery({ query: GET_DISPLAY_PROJECTS });
      if (existingProjects && newProject) {
        cache.writeQuery({
          query: GET_DISPLAY_PROJECTS,
          data: {
            home_page_project: [
              ...existingProjects.home_page_project,
              newProject,
            ],
          },
        });
      }
    },
    // onCompleted: (data) => {
    //   console.log("Project inserted:", data.insert_home_page_project_one);
    // },
  });
};

export const useUpdateProject = () => {
  return useMutation(UPDATE_PROJECT, {
    update(
      cache,
      { data: { update_home_page_project_by_pk: updatedProject } }
    ) {
      const existingProjects = cache.readQuery({ query: GET_DISPLAY_PROJECTS });
      if (existingProjects && updatedProject) {
        const updatedProjects = existingProjects.home_page_project.map(
          (project) =>
            project.id === updatedProject.id ? updatedProject : project
        );

        cache.writeQuery({
          query: GET_DISPLAY_PROJECTS,
          data: {
            home_page_project: updatedProjects,
          },
        });
      }
    },
    // onCompleted: (data) => {
    //   console.log("Project updated:", data.update_home_page_project_by_pk);
    // },
  });
};

export const useDeleteProject = () => {
  return useMutation(DELETE_PROJECT, {
    update(
      cache,
      { data: { delete_home_page_project_by_pk: deletedProject } }
    ) {
      const existingProjects = cache.readQuery({ query: GET_DISPLAY_PROJECTS });

      if (existingProjects && deletedProject) {
        const updatedProjects = existingProjects.home_page_project.filter(
          (project) => project.id !== deletedProject.id
        );

        cache.writeQuery({
          query: GET_DISPLAY_PROJECTS,
          data: {
            home_page_project: updatedProjects,
          },
        });
      }
    },
    // onCompleted: (data) => {
    //   console.log("Project deleted:", data.delete_home_page_project_by_pk);
    // },
  });
};
